import React, { useMemo } from 'react';
import { StyleSheet, Text, TouchableOpacity, View } from './rn';
import { fontSize, radius, spacing, type ThemeColors } from '../theme';
import { useTheme } from '../theme/ThemeContext';

type Props = {
  text: string;
  actionLabel: string;
  onAction: () => void;
  /** Ekranın altından uzaklık: dock varsa onun üstü, yoksa güvenli alanın üstü. */
  bottom: number;
  testID?: string;
};

// Geri alınabilen bir işlemden sonra ekranın altında beliren şerit. Gelen
// kutusunda arşivleme (4 sn) ve bildirim merkezinde "tümü okundu" (7 sn, D-672)
// aynı şeridi kullanır; süre ve geri alma mantığı ekranda kalır, görünüm burada.
export default function UndoSnackbar({ text, actionLabel, onAction, bottom, testID }: Props) {
  const colors = useTheme();
  const styles = useMemo(() => makeStyles(colors), [colors]);
  return (
    <View testID={testID} style={[styles.snackbar, { bottom }]} accessibilityLiveRegion="polite">
      <Text style={styles.text}>{text}</Text>
      <TouchableOpacity
        testID={testID ? `${testID}-action` : undefined}
        accessibilityRole="button"
        onPress={onAction}
        hitSlop={{ top: 12, bottom: 12, left: 12, right: 12 }}>
        <Text style={styles.action}>{actionLabel}</Text>
      </TouchableOpacity>
    </View>
  );
}

const makeStyles = (colors: ThemeColors) => StyleSheet.create({
  snackbar: {
    position: 'absolute',
    left: spacing.lg,
    right: spacing.lg,
    backgroundColor: colors.black,
    borderRadius: radius.control,
    paddingVertical: spacing.md,
    paddingHorizontal: spacing.lg,
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: spacing.md,
  },
  text: { flexShrink: 1, color: colors.white, fontSize: fontSize.md },
  action: { color: colors.white, fontSize: fontSize.md, fontWeight: '700' },
});
